import * as http from "@/utils/request";

//运营商级联
export function getCascade({operatorName,brand,operatorId}) {
    return http.get("/comm/getCascade",{OperatorName:operatorName,brand,operatorId})
}
//登出 /user/logout
export function logout({}){
    return http.postJSON("/user/logout",{})
}


// WEBPACK FOOTER //
// ./src/services/deviceType.js